import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import PasswordForm from "../forms/passwordForm";
import DeviceContext from "../../service/indentifyDevice";
import "../../../assets/scss/components/login/loginScreen/loginScreen.scss";
import { IPasswordFormProps } from "./../forms/passwordForm";
import logo from "../../../assets/images/logo_white.jpg";
export interface IPasswordScreenProps extends IPasswordFormProps {
	onClose?: () => void;
}

const PasswordScreen: React.FC<IPasswordScreenProps> = (props) => {
	return (
		<LoginPopup
			leftHeaderContent={!DeviceContext().isDesktop ? <img src={logo} alt="nuvama" className="nuvama_logo"/> : undefined}
			centerHeaderContent={DeviceContext().isDesktop ? <img src={logo} alt="nuvama" className="nuvama_logo"/> : undefined}
			onClose={props.onClose}
			className="login_scrn"
		>
			<PasswordForm {...props} />
		</LoginPopup>
	);
};

export default PasswordScreen;
